import { Grid } from "@mui/material";
import { memo } from "react";
import { IconBuildingPlus } from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import MxButtonStartIcon from "@rf-l1/buttons/MxButtonStartIcon";
import useCountCatchMentTotal from "../../hooks/useCountCatchMentTotal";
import { IMxCatchmentFooter } from "./model/catchment.interface";

/**
 * Footer del formulario de catchment que muestra el total de unidades
 * y proporciona un botón para agregar nuevas etapas
 */
export const MxCatchmentFooter = ({
  addItem,
  totalUnits,
  buttonLabel = "Agregar etapa",
  showTotal = true
}: IMxCatchmentFooter) => {
  const { totalUnits: calculatedTotal } = useCountCatchMentTotal();
  const finalTotal = totalUnits ?? calculatedTotal;

  return (
    <Grid
      container
      flexDirection="column"
      rowGap={2}
      justifyItems="center"
      alignItems="center"
      my={1}
    >
      <Grid item xs="auto">
        <MxButtonStartIcon
          onClick={addItem}
          label={buttonLabel}
          bgColorIcon="primary.main"
          colorText="grey.800"
          icon={<IconBuildingPlus size={19} color="white" />}
        />
      </Grid>

      {showTotal && (
        <Grid item xs="auto">
          <MxTypography
            sx={{ mx: "auto" }}
            color="primary.main"
            variant="overline"
            fontWeight={700}
          >
            {isNaN(finalTotal)
              ? "Indique las cantidades faltantes"
              : `Total de unidades del proyecto: ${finalTotal}`}
          </MxTypography>
        </Grid>
      )}
    </Grid>
  );
};

export default memo(MxCatchmentFooter);
